import { render } from "./TopbarThemeSwitcher.vue?vue&type=template&id=a13d0d66&scoped=true"
import script from "./TopbarThemeSwitcher.vue?vue&type=script&lang=js"
export * from "./TopbarThemeSwitcher.vue?vue&type=script&lang=js"

import "./TopbarThemeSwitcher.vue?vue&type=style&index=0&id=a13d0d66&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a13d0d66"]])

export default __exports__